import React from 'react';

// Ticket 195: a failed Inbox list or thread load. Replaces the empty state,
// which would read as "nothing here" when the request never succeeded.
export default function LoadError({ message, onRetry, testId }) {
  return (
    <div className="p-8 text-center text-sm" role="alert" data-testid={testId}>
      <p className="text-red-700">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        data-testid={`${testId}-retry`}
        className="mt-2 text-xs font-medium text-[#070B5F] underline"
      >
        Retry
      </button>
    </div>
  );
}
